// extracted by mini-css-extract-plugin
module.exports = {"input":"NumberEditor_input__I-IS5","editorContainer":"NumberEditor_editorContainer__2MR7r","notification":"NumberEditor_notification__1V11W"};